<template>
  <!-- Account View -->
  <MainLayout>
    <!-- Toolbar -->
    <template #toolbar />
  </MainLayout>
</template>

<script>
import MainLayout from '../../layouts/MainLayout'
import { wipeDB } from '../../db/common'
import { mapActions } from 'vuex'

export default {
  name: 'ChromeExtensionAuthView',
  components: { MainLayout },
  async mounted () {
    await this.loginUserWithToken({
      token: this.$route.params.token
    })

    // Wipe the db
    await wipeDB()
  },
  methods: {
    ...mapActions('AuthModule', ['loginUserWithToken'])
  }
}
</script>

<style scoped lang="sass"></style>
